// Module
var code = "<div layout=\"column\" class=\"full-height\"> </div> ";
// Exports
export default code;